module.exports = __webpack_public_path__ + "fonts/2bac6f9c65d2527e7b0ca9afcf87d6a5.svg";